import { useCallback, useState } from 'react';

function useButtonHover() {
  const [hovered, setHovered] = useState(false);

  const onEnter = useCallback(() => {
    setHovered(true);
  }, []);
  const onLeave = useCallback(() => {
    setHovered(false);
  }, []);

  return [hovered, onEnter, onLeave];
}

export const Effects = {
  useButtonHover,
};
